import { render, staticRenderFns } from "./Paginationx.vue?vue&type=template&id=20dc39ea&scoped=true&"
import script from "./Paginationx.vue?vue&type=script&lang=js&"
export * from "./Paginationx.vue?vue&type=script&lang=js&"
import style0 from "./Paginationx.vue?vue&type=style&index=0&id=20dc39ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dc39ea",
  null
  
)

export default component.exports